export default "__VITE_ASSET__015b5d43__"